import { render } from "./tall_land.vue?vue&type=template&id=724c7be3&scoped=true"
import script from "./tall_land.vue?vue&type=script&lang=js"
export * from "./tall_land.vue?vue&type=script&lang=js"

import "./tall_land.vue?vue&type=style&index=0&id=724c7be3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724c7be3"]])

export default __exports__